import { PAINT_PARTS, PAINT_META } from "../lib/labels";

export default function PaintMatrix({ paint }) {
  return (
    <div data-testid="paint-matrix">
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
        {PAINT_PARTS.map((p) => {
          const cond = (paint && paint[p.key]) || "belirtilmedi";
          const meta = PAINT_META[cond] || PAINT_META.orijinal;
          return (
            <div key={p.key} data-testid={`paint-matrix-${p.key.replace(/_/g, "-")}`}
              className={`flex items-center justify-between gap-2 px-3.5 py-2.5 rounded-lg border text-sm ${meta.cls}`}>
              <span className="text-slate-200">{p.label}</span>
              <span className="text-xs font-semibold whitespace-nowrap">{meta.label}</span>
            </div>
          );
        })}
      </div>
      <div className="flex flex-wrap gap-4 mt-5">
        {Object.entries(PAINT_META).map(([k, m]) => (
          <span key={k} className="flex items-center gap-2 text-xs text-slate-400">
            <span className={`w-3 h-3 rounded-sm border ${m.cls}`} /> {m.label}
          </span>
        ))}
      </div>
    </div>
  );
}
